// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Clients.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        {/* Name/Email */}
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <input type='checkbox' />
          {/* <span className={Classes.tableHeadName}>
            <h5 className="truncate">value.name</h5>
          </span> */}
        </div>
        {/* Spend */}
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{value.name}</h5>
        </div>
        {/* Bookings */}
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <h5>{value.company}</h5>
        </div>
        {/* Date Joined */}
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <h5>{value.created}</h5>
        </div>
        {/* Disable toggle */}
        <div className={`${Classes.disableToggle} ${Classes.colDisable}`}>
          <DropDown
            selectedValue={value.status}
            options={["Active", "Canceled"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>
        {/* Actions */}
        <div className={`${Classes.actions} ${Classes.colActions}`}>
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>
      </div>
    </>
  );
}
